export const SEAT_COUNT = 6;
